export enum ProcessTriggerActionButtonType {
    Execute = 'Execute'
}
